function apiBase(): string {
  const raw = import.meta.env.VITE_API_BASE_URL;
  if (typeof raw === 'string' && raw.length > 0) return raw.replace(/\/$/, '');
  return '';
}

/**
 * Distinct `ComCatBrand.brand` values (each brand listed once).
 */
export async function fetchComCatBrands(): Promise<string[]> {
  const res = await fetch(`${apiBase()}/api/v1/com-cat-brands`);
  const data = (await res.json()) as { brands?: unknown };

  if (!res.ok || !Array.isArray(data.brands)) {
    return [];
  }

  return data.brands.filter((b): b is string => typeof b === 'string' && b.length > 0);
}

/**
 * Distinct `ComCatBrand.variant` values for the given brand (ordered by weight).
 */
export async function fetchComCatVariantsForBrand(brand: string): Promise<string[]> {
  const trimmed = brand.trim();
  if (!trimmed) {
    return [];
  }

  const params = new URLSearchParams({ brand: trimmed });
  const res = await fetch(`${apiBase()}/api/v1/com-cat-brands/variants?${params.toString()}`);
  const data = (await res.json()) as { variants?: unknown };

  if (!res.ok || !Array.isArray(data.variants)) {
    return [];
  }

  return data.variants.filter((v): v is string => typeof v === 'string' && v.length > 0);
}
